<!--
  @deprecated This offer modal is part of the old offer system that is being rebuilt.
  Do not use or modify this component.
-->
<template>
  <b-modal
    v-if="lobbyOffer"
    id="modal-offer-xmas-1"
    class="custom-modal1"
    :hide-footer="true"
    modal-class="custom-modal1"
    @hidden="onHidden"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <a href="#" class="close-button" @click="close()"> </a>
    </template>

    <template slot="default">
      <div v-if="rewards[0]" class="offer-reward-container to-center-abs">
        <b-row class="position-relative w-100">
          <b-col
            cols="12"
            class="d-inline-flex align-items-center justify-content-center mb-3"
            :style="{ visibility: rewards[0].gold > 0 ? 'visible' : 'hidden' }"
          >
            <div>
              <img
                :src="$whitelabel.currencies.primary.triple"
                style="width: 200px"
              />
            </div>
          </b-col>
          <b-col
            cols="12"
            class="d-inline-flex align-items-center justify-content-center"
            :style="{ visibility: rewards[0].gold > 0 ? 'visible' : 'hidden' }"
          >
            <div class="bold yellow-text" style="font-size: 55px">
              {{ formatNumber(rewards[0].gold) }}
            </div>
          </b-col>

          <b-col cols="6" class="mx-auto" style="margin-top: 50px">
            <b-row align-h="around" align-v="center">
              <b-col
                v-if="rewards[0].card > 0"
                cols="3"
                class="p-0 align-items-center text-center"
              >
                <div class="bold yellow-text" style="font-size: 25px">
                  {{ formatNumber(rewards[0].card) }} x
                </div>
                <BaseAsset asset="cards" size="big" class="mx-auto" />
              </b-col>

              <b-col
                v-if="rewards[0].loyalty > 0"
                cols="3"
                class="p-0 align-items-center text-center"
              >
                <div class="bold yellow-text" style="font-size: 25px">
                  {{ formatNumber(rewards[0].loyalty) }} x
                </div>
                <BaseAsset asset="loyalty" size="big" />
              </b-col>

              <b-col
                v-if="rewards[0].elixir > 0"
                cols="3"
                class="p-0 align-items-center text-center"
              >
                <div class="bold yellow-text" style="font-size: 25px">
                  {{ formatNumber(rewards[0].elixir) }} x
                </div>
                <BaseAsset asset="tertiary" size="big" />
              </b-col>

              <b-col
                v-if="rewards[0].expbooster > 0"
                cols="3"
                class="p-0 align-items-center text-center"
              >
                <div class="bold yellow-text" style="font-size: 25px">
                  {{ Math.round(rewards[0].expbooster / 60) }} Min.
                </div>
                <BaseAsset asset="booster" size="big" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row align-h="center" class="w-100">
          <div class="submit-button" @click="buyItem(0, 'Offer', 'Daily')">
            <div>
              {{ $t("shop.offers.buy_button", { 0: "" }) }}
              <br />
              <span class="big position-relative"
                >{{ formatPrice(price[0]) }} €

                <div v-if="oldPrices && oldPrices[0]" class="offer-old-price">
                  {{ formatPrice(oldPrices[0]) }} €
                  <div class="offer-red-line to-center-abs"></div>
                </div>
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </template>
  </b-modal>
</template>

<script>
import offerModalContent from "@/mixins/offerModalContent.js";
import BaseAsset from "@/components/base/base-asset.vue";

export default {
  name: "ModalOfferXmas1",
  components: { BaseAsset },
  mixins: [offerModalContent],
  data() {
    return { isPipelineOffer: true };
  },

  mounted: function () {
    this.$bvModal.show("modal-offer-xmas-1");
  },
};
</script>
<style lang="scss">
$modal-width: 1200px;
$modal-height: 800px;

#modal-offer-xmas-1 {
  .modal-dialog {
    top: 50px;
    max-width: $modal-width;
    height: $modal-height;

    @media (max-height: 750px) {
      transform: scale(0.8);
      top: -60px;
      margin-bottom: -20%;
    }
  }

  .modal-content {
    width: $modal-width;
    background: url(~@/assets/img/shop/offers/offer_xmas_special.png) no-repeat;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    padding-top: 20px;
    height: 100%;
  }

  .close-button {
    top: -10px;
    right: -10px;
  }

  .offer-reward-container {
    top: 170px;
    left: 400px;
    line-height: 1.2;
    text-align: left;
    width: 700px;
    height: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .icon-gold {
      width: 10px;
      margin-left: auto;
      margin-right: auto;
    }
    .bonus-col {
      margin-top: 10px;

      .package-bonus-icons {
        padding: 0 25%;
        white-space: nowrap;

        .package-icon {
          width: 93px;
          text-align: center;
        }

        .package-bonus-icon-card {
          .text {
            color: $primary-accent;
            font-family: Ubuntu;
            font-size: 22px;
            margin-top: 5px;
            white-space: nowrap;
          }

          .icon {
            height: 46px;
            margin-left: auto;
            margin-right: auto;
          }
        }
        .package-bonus-icon-loyalty {
          .text {
            color: $primary-accent;
            font-family: Ubuntu;
            font-size: 22px;
            margin-top: 5px;
            white-space: nowrap;
          }

          .icon {
            height: 47px;
            margin-left: auto;
            margin-right: auto;
          }
        }

        .package-bonus-icon-elixir {
          .text {
            color: $primary-accent;
            font-family: Ubuntu;
            font-size: 22px;
            margin-top: 5px;
            white-space: nowrap;
          }

          .icon {
            height: 47px;
            margin-left: auto;
            margin-right: auto;
          }
        }

        .package-bonus-icon-expbooster {
          .text {
            color: $primary-accent;
            font-family: Ubuntu;
            font-size: 22px;
            margin-top: 5px;
            white-space: nowrap;
          }

          .icon {
            height: 47px;
            margin-left: auto;
            margin-right: auto;
          }
        }
      }
    }

    .submit-button {
      margin-top: 20px;
      width: 405px;
      height: 100px;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      color: white;
      text-transform: uppercase;
      cursor: pointer;
      font-family: Ubuntu-Bold;
      text-align: center;
      display: inline-flex;
      line-height: 1;
      text-shadow: 1px 2px 4px $text-shadow-dark-green;
      @media (max-width: 1300px) {
        margin-top: 35px;
      }
      .big {
        color: white;
        font-family: Ubuntu-Bold;
        font-size: 36px;
        text-shadow: 1px 2px 4px $text-shadow-dark-green;
      }

      .offer-old-price {
        top: -55px;
        right: -130px;
      }

      .big-badge-more-percent {
        top: -625px;
        right: -435px;
      }
    }
  }
}
</style>
